export enum NotificationTab {
	Unread = 0,
	All = 1,
}

export const NOTIFICATION_TAB_STORAGE_KEY = "notification-tab";
